/**
 * 간격 상수 정의
 * 일관된 간격 시스템 제공
 */

export const spacing = {
  // 기본 간격 (2px 단위)
  xs: '2px',   // 1 * 2px
  sm: '4px',   // 2 * 2px
  md: '8px',   // 4 * 2px
  lg: '16px',  // 8 * 2px
  xl: '20px',  // 10 * 2px
  xxl: '24px', // 12 * 2px
  
  // 특수 간격
  labelWidth: '70px',      // 레이블 너비
  buttonMarginLeft: '85px', // 버튼 왼쪽 마진
  buttonMarginRight: '41px', // 버튼 우측 마진 (우측 정렬 시 사용)
  buttonSpacing: '5px', // 버튼 사이 간격
  buttonHeight: '26px', // 버튼 높이
  buttonWidth: '70px', // 버튼 너비
  searchFormMargin: '0px', // 검색 폼 마진
  
  // 그리드 열 크기
  gridColumnWidth: '230px', // 1~5열 고정 너비
  gridColumn6MinWidth: '450px', // 6열 최소 너비
  
  // 입력 필드 크기
  dateInputWidth: '130px', // 날짜 입력 필드 너비
  textInputWidth: '133.7px', // 텍스트 입력 필드 너비
  numberInputWidth: '60px', // 숫자 입력 필드 너비
  numberInputHeight: '8px', // 숫자 입력 필드 높이
  autoCompleteInputWidth: '133.7px', // 자동완성 입력 필드 기본 너비
  selectInputWidth: '133.7px', // 선택 입력 필드 기본 너비
  checkboxSize: '26px', // 체크박스 크기
  
  // 로더 크기
  loaderWidth: 100, // JqxLoader 너비
  loaderHeight: 60, // JqxLoader 높이
  
  // 메뉴 크기
  menuMaxHeight: 400, // Menu 최대 높이
  menuWidth: 200, // Menu 너비
};

export default spacing;

